/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Footer_Note_TakingInputs */

const en_app_footer_note_taking = /** @type {(inputs: App_Footer_Note_TakingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1-Click Note Taking`)
};

const es_app_footer_note_taking = /** @type {(inputs: App_Footer_Note_TakingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas con 1 clic`)
};

/**
* | output |
* | --- |
* | "1-Click Note Taking" |
*
* @param {App_Footer_Note_TakingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const app_footer_note_taking = /** @type {((inputs?: App_Footer_Note_TakingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Footer_Note_TakingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_app_footer_note_taking(inputs)
	return en_app_footer_note_taking(inputs)
});